import React, { useEffect, useState } from 'react';
import 'scss/abstract.scss'; // Asegúrate de que la ruta al archivo SCSS sea correcta

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <button
      className="scroll-to-top"
      onClick={scrollToTop}
      style={{ display: isVisible ? 'block' : 'none' }}
      aria-label="Subir al inicio de la página"
    >
      ↑ {/* Puedes reemplazar esto con un ícono, como <FaArrowUp /> de react-icons */}
    </button>
  );
};

export default ScrollToTop;